enum ContactSource {
  file = "file",
  leedpulse = "leedpulse",
}

export const contactSourceAsString = (contactSource: ContactSource): string => {
  switch (contactSource) {
    case ContactSource.file:
      return "Fichier";
    case ContactSource.leedpulse:
      return "Leedpulse SaaS (formulaire)";
    default:
      return "";
  }
};

export default ContactSource;
